import {
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <footer className="bg-footer_clr text-black mt-16 ">
        {/* Top Section */}
        <div className=" px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6  mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1.2fr_0.8fr] gap-10">
            {/* Brand */}
            <div>
              <a
                href="/"
                className="text-4xl font-serif font-semibold tracking-wider hover:text-hover_dark_primary transition"
              >
                LEGACY DECOR
              </a>

              <p className="text-[15px] leading-7 max-w-md mt-2">
                Premium Home Decor, Gift Articles, German Silver Items, Antique
                Collections, Wall Decor and Luxury Home Accessories.
              </p>

              <iframe
                title="Store Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.1287425717787!2d72.5130087738657!3d23.019044716462606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b7d28f73cb3%3A0x7f1a31b92e348f3!2sLegacy%20Decor!5e0!3m2!1sen!2sin!4v1758555085224!5m2!1sen!2sin"
                width="90%"
                height="200"
                className="rounded-lg shadow-lg mt-3"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            {/* Categories */}
            <div>
              <h3 className="text-xl font-semibold mb-5">Categories</h3>

              <ul className="space-y-3 text-[16px]">
                <li>
                  <a
                    href="/products/paintings"
                    className="hover:text-hover_dark_primary"
                  >
                    Paintings
                  </a>
                </li>

                <li>
                  <a
                    href="/products/wall-decor"
                    className="hover:text-hover_dark_primary"
                  >
                    Wall Decor
                  </a>
                </li>

                <li>
                  <a
                    href="/products/wall-clocks"
                    className="hover:text-hover_dark_primary"
                  >
                    Wall Clocks
                  </a>
                </li>

                <li>
                  <a
                    href="/products/frames"
                    className="hover:text-hover_dark_primary"
                  >
                    Frames
                  </a>
                </li>

                <li>
                  <a
                    href="/products/german-silver-items"
                    className="hover:text-hover_dark_primary"
                  >
                    German Silver
                  </a>
                </li>

                <li>
                  <a
                    href="/categories"
                    className="hover:text-hover_dark_primary"
                  >
                    View All
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-xl font-semibold mb-5">Contact Us</h3>

              <div className="space-y-4 text-[15px]">
                <p className="flex items-start gap-3">
                  <FaMapMarkerAlt className="mt-1 text-hover_dark_primary " />
                  shop no 6, Ratnakar atelier,
                  <br /> jodhpur gam road, ramdev nagar,
                  <br />
                  Satellite, Ahmedabad, Gujarat 380015
                </p>

                <p className="flex gap-3">
                  <FaPhoneAlt className="text-hover_dark_primary mt-1" />
                  <div className="block">
                    <a href="tel:+919825081632" className="block ">
                      (+91) 9825081632
                    </a>
                    <a href="tel:+919227071152" className="block ">
                      (+91) 9227071152
                    </a>

                    <a href="tel:+917935565758" className=" ">
                      079 35565758
                    </a>
                  </div>
                </p>

                <p className="flex items-center gap-3">
                  <FaEnvelope className="text-hover_dark_primary mt-1" />
                  <a
                    href="mailto:legacydecorvintage@gmail.com"
                    className="hover:text-hover_dark_primary hover:underline transition"
                  >
                    legacydecorvintage@gmail.com
                  </a>
                </p>
              </div>
            </div>

            {/* Social */}
            <div>
              <h3 className="text-xl font-semibold mb-5">Follow Us</h3>

              <div className="flex gap-5 text-3xl">
                <a
                  href="https://instagram.com/legacydecor.in"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-hover_dark_primary "
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://facebook.com/legacydecor.in"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-hover_dark_primary "
                >
                  <FaFacebookF />
                </a>

                <a
                  href="https://wa.me/919825081632"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-hover_dark_primary "
                >
                  <FaWhatsapp />
                </a>
              </div>

              <div>
                <h3 className="text-xl font-semibold mt-9 mb-3">We Accept</h3>
                <img src="/img/payment.png" />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-black/10">
          <div className="px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-5 mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-center text-sm">
              <a
                href="/shipping-policy"
                className="hover:text-hover_dark_primary transition"
              >
                Shipping Policy
              </a>

              <a
                href="/refund-policy"
                className="hover:text-hover_dark_primary transition"
              >
                Refund Policy
              </a>

              <a
                href="/terms-and-conditions"
                className="hover:text-hover_dark_primary transition"
              >
                Terms & Conditions
              </a>

              {/* <a
                href="/cancellation-policy"
                className="hover:text-hover_dark_primary transition"
              >
                Cancellation Policy
              </a> */}

              <a
                href="/privacy-policy"
                className="hover:text-hover_dark_primary transition"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        {/* Payment Section */}
        <div className="mb-5 mt-2">
          <p className="text-center">
            © 2025 Legacy Decor. All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
